module.exports = "<p ng-if=!$ctrl.isLoggedIn() translate>Please log in.</p> <p ng-if=\"$ctrl.isLoggedIn() && !$ctrl.canViewSite()\" translate> You do not have permission to access this site. </p> <div ng-if=\"$ctrl.isLoggedIn() && $ctrl.canViewSite()\"> <app-home-navbar></app-home-navbar> <ui-view></ui-view> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/home/component_partial.html
// module id = 413
// module chunks = 0